import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\OfferController::redeem
 * @see app/Http/Controllers/OfferController.php:94
 * @route '/offers/{offerDomain}/{offerCode}/redeem'
 */
export const redeem = (args: { offerDomain: string | number, offerCode: string | number } | [offerDomain: string | number, offerCode: string | number ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: redeem.url(args, options),
    method: 'post',
})

redeem.definition = {
    methods: ["post"],
    url: '/offers/{offerDomain}/{offerCode}/redeem',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\OfferController::redeem
 * @see app/Http/Controllers/OfferController.php:94
 * @route '/offers/{offerDomain}/{offerCode}/redeem'
 */
redeem.url = (args: { offerDomain: string | number, offerCode: string | number } | [offerDomain: string | number, offerCode: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
                    offerDomain: args[0],
                    offerCode: args[1],
                }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
                        offerDomain: args.offerDomain,
                                offerCode: args.offerCode,
                }

    return redeem.definition.url
            .replace('{offerDomain}', parsedArgs.offerDomain.toString())
            .replace('{offerCode}', parsedArgs.offerCode.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\OfferController::redeem
 * @see app/Http/Controllers/OfferController.php:94
 * @route '/offers/{offerDomain}/{offerCode}/redeem'
 */
redeem.post = (args: { offerDomain: string | number, offerCode: string | number } | [offerDomain: string | number, offerCode: string | number ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: redeem.url(args, options),
    method: 'post',
})

    /**
* @see \App\Http\Controllers\OfferController::redeem
 * @see app/Http/Controllers/OfferController.php:94
 * @route '/offers/{offerDomain}/{offerCode}/redeem'
 */
    const redeemForm = (args: { offerDomain: string | number, offerCode: string | number } | [offerDomain: string | number, offerCode: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
        action: redeem.url(args, options),
        method: 'post',
    })

            /**
* @see \App\Http\Controllers\OfferController::redeem
 * @see app/Http/Controllers/OfferController.php:94
 * @route '/offers/{offerDomain}/{offerCode}/redeem'
 */
        redeemForm.post = (args: { offerDomain: string | number, offerCode: string | number } | [offerDomain: string | number, offerCode: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
            action: redeem.url(args, options),
            method: 'post',
        })
    
    redeem.form = redeemForm
/**
* @see \App\Http\Controllers\OfferController::unredeem
 * @see app/Http/Controllers/OfferController.php:99
 * @route '/offers/{offerDomain}/{offerCode}/unredeem'
 */
export const unredeem = (args: { offerDomain: string | number, offerCode: string | number } | [offerDomain: string | number, offerCode: string | number ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: unredeem.url(args, options),
    method: 'post',
})

unredeem.definition = {
    methods: ["post"],
    url: '/offers/{offerDomain}/{offerCode}/unredeem',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\OfferController::unredeem
 * @see app/Http/Controllers/OfferController.php:99
 * @route '/offers/{offerDomain}/{offerCode}/unredeem'
 */
unredeem.url = (args: { offerDomain: string | number, offerCode: string | number } | [offerDomain: string | number, offerCode: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
                    offerDomain: args[0],
                    offerCode: args[1],
                }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
                        offerDomain: args.offerDomain,
                                offerCode: args.offerCode,
                }

    return unredeem.definition.url
            .replace('{offerDomain}', parsedArgs.offerDomain.toString())
            .replace('{offerCode}', parsedArgs.offerCode.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\OfferController::unredeem
 * @see app/Http/Controllers/OfferController.php:99
 * @route '/offers/{offerDomain}/{offerCode}/unredeem'
 */
unredeem.post = (args: { offerDomain: string | number, offerCode: string | number } | [offerDomain: string | number, offerCode: string | number ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: unredeem.url(args, options),
    method: 'post',
})

    /**
* @see \App\Http\Controllers\OfferController::unredeem
 * @see app/Http/Controllers/OfferController.php:99
 * @route '/offers/{offerDomain}/{offerCode}/unredeem'
 */
    const unredeemForm = (args: { offerDomain: string | number, offerCode: string | number } | [offerDomain: string | number, offerCode: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
        action: unredeem.url(args, options),
        method: 'post',
    })

            /**
* @see \App\Http\Controllers\OfferController::unredeem
 * @see app/Http/Controllers/OfferController.php:99
 * @route '/offers/{offerDomain}/{offerCode}/unredeem'
 */
        unredeemForm.post = (args: { offerDomain: string | number, offerCode: string | number } | [offerDomain: string | number, offerCode: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
            action: unredeem.url(args, options),
            method: 'post',
        })
    
    unredeem.form = unredeemForm
/**
* @see \App\Http\Controllers\OfferController::validateBooking
 * @see app/Http/Controllers/OfferController.php:288
 * @route '/{offerDomain}/{offerCode}/book/validate'
 */
export const validateBooking = (args: { offerDomain: string | number, offerCode: string | number } | [offerDomain: string | number, offerCode: string | number ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: validateBooking.url(args, options),
    method: 'post',
})

validateBooking.definition = {
    methods: ["post"],
    url: '/{offerDomain}/{offerCode}/book/validate',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\OfferController::validateBooking
 * @see app/Http/Controllers/OfferController.php:288
 * @route '/{offerDomain}/{offerCode}/book/validate'
 */
validateBooking.url = (args: { offerDomain: string | number, offerCode: string | number } | [offerDomain: string | number, offerCode: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
                    offerDomain: args[0],
                    offerCode: args[1],
                }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
                        offerDomain: args.offerDomain,
                                offerCode: args.offerCode,
                }

    return validateBooking.definition.url
            .replace('{offerDomain}', parsedArgs.offerDomain.toString())
            .replace('{offerCode}', parsedArgs.offerCode.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\OfferController::validateBooking
 * @see app/Http/Controllers/OfferController.php:288
 * @route '/{offerDomain}/{offerCode}/book/validate'
 */
validateBooking.post = (args: { offerDomain: string | number, offerCode: string | number } | [offerDomain: string | number, offerCode: string | number ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: validateBooking.url(args, options),
    method: 'post',
})

    /**
* @see \App\Http\Controllers\OfferController::validateBooking
 * @see app/Http/Controllers/OfferController.php:288
 * @route '/{offerDomain}/{offerCode}/book/validate'
 */
    const validateBookingForm = (args: { offerDomain: string | number, offerCode: string | number } | [offerDomain: string | number, offerCode: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
        action: validateBooking.url(args, options),
        method: 'post',
    })

            /**
* @see \App\Http\Controllers\OfferController::validateBooking
 * @see app/Http/Controllers/OfferController.php:288
 * @route '/{offerDomain}/{offerCode}/book/validate'
 */
        validateBookingForm.post = (args: { offerDomain: string | number, offerCode: string | number } | [offerDomain: string | number, offerCode: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
            action: validateBooking.url(args, options),
            method: 'post',
        })
    
    validateBooking.form = validateBookingForm
/**
* @see \App\Http\Controllers\OfferController::book
 * @see app/Http/Controllers/OfferController.php:394
 * @route '/{offerDomain}/{offerCode}/book'
 */
export const book = (args: { offerDomain: string | number, offerCode: string | number } | [offerDomain: string | number, offerCode: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: book.url(args, options),
    method: 'get',
})

book.definition = {
    methods: ["get","head"],
    url: '/{offerDomain}/{offerCode}/book',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\OfferController::book
 * @see app/Http/Controllers/OfferController.php:394
 * @route '/{offerDomain}/{offerCode}/book'
 */
book.url = (args: { offerDomain: string | number, offerCode: string | number } | [offerDomain: string | number, offerCode: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
                    offerDomain: args[0],
                    offerCode: args[1],
                }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
                        offerDomain: args.offerDomain,
                                offerCode: args.offerCode,
                }

    return book.definition.url
            .replace('{offerDomain}', parsedArgs.offerDomain.toString())
            .replace('{offerCode}', parsedArgs.offerCode.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\OfferController::book
 * @see app/Http/Controllers/OfferController.php:394
 * @route '/{offerDomain}/{offerCode}/book'
 */
book.get = (args: { offerDomain: string | number, offerCode: string | number } | [offerDomain: string | number, offerCode: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: book.url(args, options),
    method: 'get',
})
/**
* @see \App\Http\Controllers\OfferController::book
 * @see app/Http/Controllers/OfferController.php:394
 * @route '/{offerDomain}/{offerCode}/book'
 */
book.head = (args: { offerDomain: string | number, offerCode: string | number } | [offerDomain: string | number, offerCode: string | number ], options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: book.url(args, options),
    method: 'head',
})

    /**
* @see \App\Http\Controllers\OfferController::book
 * @see app/Http/Controllers/OfferController.php:394
 * @route '/{offerDomain}/{offerCode}/book'
 */
    const bookForm = (args: { offerDomain: string | number, offerCode: string | number } | [offerDomain: string | number, offerCode: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
        action: book.url(args, options),
        method: 'get',
    })

            /**
* @see \App\Http\Controllers\OfferController::book
 * @see app/Http/Controllers/OfferController.php:394
 * @route '/{offerDomain}/{offerCode}/book'
 */
        bookForm.get = (args: { offerDomain: string | number, offerCode: string | number } | [offerDomain: string | number, offerCode: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
            action: book.url(args, options),
            method: 'get',
        })
            /**
* @see \App\Http\Controllers\OfferController::book
 * @see app/Http/Controllers/OfferController.php:394
 * @route '/{offerDomain}/{offerCode}/book'
 */
        bookForm.head = (args: { offerDomain: string | number, offerCode: string | number } | [offerDomain: string | number, offerCode: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
            action: book.url(args, {
                        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
                            _method: 'HEAD',
                            ...(options?.query ?? options?.mergeQuery ?? {}),
                        }
                    }),
            method: 'get',
        })
    
    book.form = bookForm
/**
* @see \App\Http\Controllers\OfferController::image
 * @see app/Http/Controllers/OfferController.php:460
 * @route '/storage/offer-images/{filename}'
 */
export const image = (args: { filename: string | number } | [filename: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: image.url(args, options),
    method: 'get',
})

image.definition = {
    methods: ["get","head"],
    url: '/storage/offer-images/{filename}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\OfferController::image
 * @see app/Http/Controllers/OfferController.php:460
 * @route '/storage/offer-images/{filename}'
 */
image.url = (args: { filename: string | number } | [filename: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { filename: args }
    }

    
    if (Array.isArray(args)) {
        args = {
                    filename: args[0],
                }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
                        filename: args.filename,
                }

    return image.definition.url
            .replace('{filename}', parsedArgs.filename.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\OfferController::image
 * @see app/Http/Controllers/OfferController.php:460
 * @route '/storage/offer-images/{filename}'
 */
image.get = (args: { filename: string | number } | [filename: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: image.url(args, options),
    method: 'get',
})
/**
* @see \App\Http\Controllers\OfferController::image
 * @see app/Http/Controllers/OfferController.php:460
 * @route '/storage/offer-images/{filename}'
 */
image.head = (args: { filename: string | number } | [filename: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: image.url(args, options),
    method: 'head',
})

    /**
* @see \App\Http\Controllers\OfferController::image
 * @see app/Http/Controllers/OfferController.php:460
 * @route '/storage/offer-images/{filename}'
 */
    const imageForm = (args: { filename: string | number } | [filename: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
        action: image.url(args, options),
        method: 'get',
    })

            /**
* @see \App\Http\Controllers\OfferController::image
 * @see app/Http/Controllers/OfferController.php:460
 * @route '/storage/offer-images/{filename}'
 */
        imageForm.get = (args: { filename: string | number } | [filename: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
            action: image.url(args, options),
            method: 'get',
        })
            /**
* @see \App\Http\Controllers\OfferController::image
 * @see app/Http/Controllers/OfferController.php:460
 * @route '/storage/offer-images/{filename}'
 */
        imageForm.head = (args: { filename: string | number } | [filename: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
            action: image.url(args, {
                        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
                            _method: 'HEAD',
                            ...(options?.query ?? options?.mergeQuery ?? {}),
                        }
                    }),
            method: 'get',
        })
    
    image.form = imageForm
const OfferController = { redeem, unredeem, validateBooking, book, image }

export default OfferController